import { z } from 'zod';

import {
    createDeleteSchema,
    createUpdateSchemaFromAdd,
    optionalBoolean,
    optionalString,
    optionalUuid,
    requiredNumber,
    requiredString,
    requiredUuid,
} from './fields';
import { SYNC_UPDATE_VALIDATION_SCHEMA } from './common';

export const createEventsAddSchema = () =>
    z
        .object({
            id: requiredUuid(),
            user_id: requiredUuid(),
            organisation_id: requiredUuid(),
            location_id: optionalUuid(),
            title: optionalString(),
            address: optionalString(),
            starts_time: requiredString().min(1),
            ends_time: requiredString().min(1),
            notes: optionalString(),
            user_reminder: optionalString(),
            send_reminders_to_contacts: optionalBoolean(),
            send_reminders_to_owners: optionalBoolean(),
            send_invites_to_contacts: optionalBoolean(),
            send_invites_to_contacts_at: optionalString(),
            send_invites_to_owners: optionalBoolean(),
            timezone: optionalString(),
            category: optionalString(),
            is_recurring: optionalBoolean(),
            recurrence_pattern: optionalString(),
            recurrence_end_date: optionalString(),
            original_event_id: optionalUuid(),
            created_at: requiredNumber(),
            updated_at: requiredNumber(),
            _status: optionalString(),
            _changed: optionalString(),
        })
        .strict();

export const createEventsUpdateSchema = () =>
    createUpdateSchemaFromAdd(
        createEventsAddSchema(),
        SYNC_UPDATE_VALIDATION_SCHEMA.events,
    );

export const createEventsDeleteSchema = () => createDeleteSchema();

export const createEventsSchemas = () => ({
    add: createEventsAddSchema(),
    update: createEventsUpdateSchema(),
    delete: createEventsDeleteSchema(),
});
